import React from 'react';
import c from 'classnames';
var RadioOption = function (_a) {
    var label = _a.label, onChange = _a.onChange, checked = _a.checked, value = _a.value, Icon = _a.icon, className = _a.className, iconCheckedClassName = _a.iconCheckedClassName, labelClassName = _a.labelClassName, radioClassName = _a.radioClassName, iconClassName = _a.iconClassName;
    return (React.createElement("label", { className: className },
        Icon && (React.createElement("span", { className: c(iconClassName, checked && iconCheckedClassName) },
            React.createElement(Icon, null))),
        React.createElement("span", { className: labelClassName }, label),
        React.createElement("input", { type: "radio", className: radioClassName, value: value, onChange: onChange, onKeyDown: function (e) {
                if (e.key === 'Enter' || e.key === 'Space') {
                    onChange(e);
                }
            }, checked: checked })));
};
RadioOption.displayName = 'RadioOption';
export default RadioOption;
//# sourceMappingURL=RadioOption.js.map